/**
  Die debounce-Funktion debounced eine andere (übergebene) Funktion um eine (in Millisekunden) vorgegeben Dauer.
  Die debounce-Funktion liefert eine debouncte-Funktion zurück. Diese debouncte ruft im wesentlichen die eigentliche Funktion auf
  debounce bedeutet: 
  - Der Aufruf der Funktion wird um die angegebene Zeit verzögert ausgeführt
  - Wenn innerhalb dieser Zeit die Funktion erneut aufgerufen wird, wird der Timeout resettet.
  
  Beispiel:
  function x(val){console.log(val)};
  let xd = debounce(x,100);
  
  xd("X");
  // Gibt nach 100 ms auf der Console "X" aus
  
  ...
  xd("X");
  // 10 ms später
  xd("Y");
  // 10 ms später
  xd("Z");
  // 100ms warten
  // Gibt auf der Console "Z" aus; "X"" und "Y" werden NICHT ausgegegeben

  
 */
export default function debounce(func, ms) {
  let timer = null;
  return function () {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(null, args);
      timer = null;
    }, ms);
  };
}